import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useBreadcrumb } from "@/contexts/BreadcrumbContext";

export function CreateArtist() {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { setBreadcrumbs, clearBreadcrumbs } = useBreadcrumb();

  useEffect(() => {
    setBreadcrumbs([
      { label: "Admin", path: "/admin" },
      { label: "Artists", path: "/admin/artists" },
      { label: "Create", path: "/admin/artists/create" },
    ]);

    return () => {
      clearBreadcrumbs();
    };
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    setIsLoading(true);

    try {
      const response = await fetch("/api/admin/artists", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, name }),
      });

      const data = await response.json();

      if (response.ok) {
        navigate("/admin/artists");
      } else {
        setError(data.error || "Failed to create artist");
      }
    } catch (err) {
      setError("An error occurred. Please try again.");
      console.error("Create artist error:", err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="p-4 max-w-md">
      <h1 className="text-2xl font-semibold mb-4">Create Artist</h1>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div className="space-y-2">
          <Label htmlFor="email">Email</Label>
          <Input
            id="email"
            type="email"
            placeholder="you@example.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div className="space-y-2">
          <Label htmlFor="name">Artist Name</Label>
          <Input
            id="name"
            type="text"
            placeholder="Artist name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
        </div>
        {error && (
          <div className="text-sm text-red-500">{error}</div>
        )}
        <div className="flex gap-2">
          <Button
            type="button"
            variant="outline"
            onClick={() => navigate("/admin/artists")}
            disabled={isLoading}
          >
            Cancel
          </Button>
          <Button type="submit" disabled={isLoading}>
            {isLoading ? "Creating..." : "Create"}
          </Button>
        </div>
      </form>
    </div>
  );
}
